/** Body copy scale (rem) — bumped ~2–3px vs prior defaults */
export const bodyText = {
  sm: "0.9rem",
  md: "1.0625rem",
  lg: "1.2rem",
  xl: "1.35rem",
};

/** Shared dark-mode tokens for dtusa marketing sections */
export const NA_PRIMARY = "#C66067";
export const NA_SECONDARY = "#70AEB8";
export const NA_ACCENT = "#E8888E";

export const DARK_OVERLAY_STRONG =
  "linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.8) 100%)";

export const DARK_OVERLAY_VIDEO =
  "linear-gradient(180deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.88) 100%), rgba(198, 96, 103, 0.3)";

export const naGradientLine = {
  background: `linear-gradient(90deg, ${NA_PRIMARY}, ${NA_SECONDARY})`,
};

export const naCardBg = "rgba(0, 0, 0, 0.78)";
export const naCardBgHover = "rgba(0, 0, 0, 0.9)";
export const naCardBorder = "1px solid rgba(255, 255, 255, 0.18)";

export const naReadableText = {
  color: "rgba(255, 255, 255, 0.95)",
  textShadow: "0 1px 3px rgba(0, 0, 0, 0.8)",
};

export const naMutedText = {
  color: "rgba(255, 255, 255, 0.82)",
  textShadow: "0 1px 2px rgba(0, 0, 0, 0.6)",
};

export const naGradientTitleStyle = {
  background: `linear-gradient(135deg, ${NA_PRIMARY} 0%, ${NA_SECONDARY} 100%)`,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

export const naDarkCardBase = {
  background: naCardBg,
  backdropFilter: "blur(12px)",
  border: naCardBorder,
};

export function darkSectionBg(image, fixed = true) {
  return {
    backgroundImage: `${DARK_OVERLAY_STRONG}, url(${image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: fixed ? "fixed" : "scroll",
  };
}

export function onDarkCardEnter(e, accent = NA_PRIMARY) {
  e.currentTarget.style.background = naCardBgHover;
  e.currentTarget.style.borderColor = `${accent}66`;
  e.currentTarget.style.transform = "translateY(-4px)";
  e.currentTarget.style.boxShadow = `0 16px 40px ${accent}33`;
}

export function onDarkCardLeave(e) {
  e.currentTarget.style.background = naCardBg;
  e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.18)";
  e.currentTarget.style.transform = "translateY(0)";
  e.currentTarget.style.boxShadow = "none";
}
